import { enUS } from "@mui/material/locale"
import { ThemeProvider, createTheme, useTheme } from "@mui/material/styles"
import { LocalizationProvider as DateLocalizationProvider } from "@mui/x-date-pickers"
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3"
import { enUS as en } from "date-fns/locale"
import find from "lodash-es/find"
import { useEffect } from "react"
import { useTranslation } from "react-i18next"

import { setLocale } from "@sap/utils/formatNumber"

import allLangs from "./langs"

// ----------------------------------------------------------------------

export default function LocalizationProvider({ children }: { children: React.ReactNode }) {
  const outerTheme = useTheme()
  const { i18n } = useTranslation()

  const currentLang = find(allLangs, { value: i18n.language })

  const theme = createTheme(outerTheme, currentLang?.systemValue || enUS)

  useEffect(() => {
    setLocale(i18n.language)
  }, [i18n.language])

  return (
    <ThemeProvider theme={theme}>
      <DateLocalizationProvider
        dateAdapter={AdapterDateFns}
        adapterLocale={currentLang?.dateLocales || en}
      >
        {children}
      </DateLocalizationProvider>
    </ThemeProvider>
  )
}
